import useAxiosInterceptor from '../interceptor';
import { apiPath } from './constants';

class PatientService {
  private axiosInstance;

  constructor() {
    // eslint-disable-next-line react-hooks/rules-of-hooks -- factory, not a React hook (matches npcLogService)
    this.axiosInstance = useAxiosInterceptor();
  }

  getSinglePatient = (payload: any) => {
    return this.axiosInstance.get(`${apiPath.PATIENT}/${payload.patientId}`);
  };

  createPatient = (payload: any) => {
    const headers = {
      Facility_id: payload.facilityUuid,
    };

    return this.axiosInstance.post(`${apiPath.PATIENT}`, payload, {
      headers: headers,
    });
  };
  editPatient = (payload: any) => {
    const headers = {
      Facility_id: payload.facilityUuid,
    };
    return this.axiosInstance.put(`${apiPath.PATIENT}/update`, payload, {
      headers: headers,
    });
  };

  deactivatePatient = (payload: any) => {
    const headers = {
      Facility_id: payload.facilityUuid,
    };
    return this.axiosInstance.delete(
      `${apiPath.PATIENT}/${payload?.patientId}?active=${payload?.active}`,
      {
        headers: headers,
        // params:payload?.active
      }
    );
  };

  getAllPhysician = (payload: any) => {
    return this.axiosInstance.get(`${apiPath.PHYSICIAN}/list`, {
      params: {
        ...payload,
      },
    });
  };

  getPayerPlanType = () => {
    return this.axiosInstance.get(`${apiPath.PAYERPLAN}/payer-type`);
  };

  createPatientPayer = (payload: any) => {
    return this.axiosInstance.post(`provider/patient-payers`, {
      ...payload,
    });
  };

  updatePatientPayer = (payload: any) => {
    return this.axiosInstance.put(`provider/patient-payers/payer/${payload?.payerUuid}`, {
      ...payload,
    });
  };

  getAllPatientPayers = (payload: any) => {
    return this.axiosInstance.get(`provider/patient-payers/${payload?.patientUuid}/all`, {
      params: {
        page: payload.page,
        pageSize: payload.pageSize,
        sortBy: payload.sortBy,
        programType: payload.programType,
        searchString: payload.searchString,
      },
    });
  };

  getPayerOptions = (payload: any) => {
    return this.axiosInstance.get(`provider/patient-payers/payer-options`, {
      params: { patientUuid: payload?.patientUuid },
    });
  };

  getPayerDateRanges = (payload: any) => {
    return this.axiosInstance.get(`provider/patient-payers/${payload?.patientUuid}/date-ranges`, {
      params: { programType: payload?.programType },
    });
  };

  getPayerHistory = (payload: any) => {
    return this.axiosInstance.get(`provider/patient-payers/history/patient`, {
      params: {
        patientUuid: payload?.patientUuid,
        ...(payload?.patientPayerUuid ? { patientPayerUuid: payload.patientPayerUuid } : {}),
        page: payload?.page ?? 0,
        pageSize: payload?.pageSize ?? 20,
      },
    });
  };

  getAllPatientPriorCharges = (patientUuid: string) => {
    return this.axiosInstance.get(`${apiPath.GET_ALL_PATIENT_PRIOR_CHARGES}/${patientUuid}`);
  };

  // Validate payer edit against MDS assessment ARDs
  validateMdsPayer = (payload: any) => {
    return this.axiosInstance.post('provider/patient-payers/validate-mds-payer', payload);
  };
}

const patientService = new PatientService();

Object.freeze(patientService);

export default patientService;
